import { Theme } from '@/theme';
import styled, { css } from 'styled-components';

export const PopupContainer = styled.div`
  margin-bottom: 16px;
  align-items: center;
  display: flex;
  gap: 16px;

  h4 {
    font-size: ${Theme.rems(18)};
    width: calc(100% - 112px);

    text-align: center;
    line-height: 120%;
  }

  svg {
    transform: rotate(180deg);
  }
`;

export const ItemsContainer = styled.div`
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: no-wrap;

  display: flex;
  height: 40px;

  @media (max-width: 359px) {
    height: 32px;
  }
`;

type ItemAttrubites = {
  isActive: boolean;
  value: string;
};

export const Item = styled.div(
  ({ isActive, value }: ItemAttrubites) => css`
    border: 2px solid ${Theme.color.grey};
    background: ${value};
    border-radius: 8px;

    width: 38.7px;
    height: 100%;

    @media (max-width: 359px) {
      width: 30.97px;
    }

    ${isActive &&
    css`
      box-shadow: 0px -4px 0px 0px rgb(0 0 0 / 0.3) inset;
      border-color: ${Theme.color.orange};
    `}
  `
);
